// import { StreamInvocationMessage } from "@aspnet/signalr";
import { Boxes } from "./boxes.model";
import { Shipment } from ".";

export class AssignShipmentWarehousing {
    shipmentNumber: string;
    shipmentNumberS: string;
    cols?: string;
    note: string;
    totalBox: number;
    weight: number;
    calWeight: number;
    isCheck: boolean;
    isPushCustomer: boolean;
    typeWarehousing: number;
    listGoodsId: number;
    packageId?: number;
    serviceId: number;
    toHubId: number;
    toProvinceId: number;
    toDistrictId: number;
    toWardId: number;
    shippingAddress: string;
    content: string;
    cusNote: string;
    length: number;
    width: number;
    height: number;
    isCheckSchedule: boolean;
    isPackage: boolean;
    doc?: number = 0;
    boxes?: Shipment[] = [];
    toUserId?: number;
    toPOHubId?: number;
    isInside: boolean = true;
    compartmentCode: string;
    compartmentId: number;
    shipmentStatusId : number;
    shipmentStatusIds : number[] = [];
    currentListGoodsId: number;
    deliveryTruckId: number;
    isBulky: boolean;
    totalItem: number;
    isLo: boolean;
    shipmentBoxIds: any[]=[];
    shipmentListGoodsId: number;
    shipmentContractNumber:string;
    toHubFilterId?:number;
}